import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, filter, of, switchMap, tap, withLatestFrom } from 'rxjs';
import { OnboardingService } from '../../generated/auth/services/onboarding.service';
import {
  loadOnboardingInfoList,
  loadOnboardingInfoListFailure,
  loadOnboardingInfoListSuccess,
  toggleLoadingStatus,
} from './onboarding-info.actions';
import { selectOnboardingInfoLoading } from './onboarding-info.selectors';

@Injectable()
export class UIEffect {
  private readonly action$ = inject(Actions);
  private readonly store = inject(Store);
  private readonly service = inject(OnboardingService);

  constructor() {}

  loadOnboardingInfoList = createEffect(() =>
    this.action$.pipe(
      ofType(loadOnboardingInfoList),
      withLatestFrom(this.store.select(selectOnboardingInfoLoading)),
      filter(([action, status]) => !status),
      tap(() => this.store.dispatch(toggleLoadingStatus({ status: true }))),
      switchMap(() =>
        this.service.onboardingProposalGetCurrentOnboardingsInfoGet().pipe(
          switchMap((response) => of(loadOnboardingInfoListSuccess({ payload: response.result }))),
          catchError((error) => of(loadOnboardingInfoListFailure({ error }))),
        ),
      ),
    ),
  );
}
